var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.5 18.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2,0H14H5.4H2.2C1,0,0,1,0,2.2v2.4v8.6c0,1.2,1,2.2,2.2,2.2h3c0.4,0,0.7,0.2,0.9,0.4l2,2.2c0.1,0.1,0.1,0.1,0.2,0.2 c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1 c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2l1.9-2.1c0.1-0.1,0.1-0.1,0.2-0.2 c0.1-0.1,0.3-0.2,0.5-0.2c0.1,0,0.2,0,0.3,0h3c1.2,0,2.2-1,2.2-2.2V4.7V2.2C19.5,1,18.5,0,17.2,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.9757acc3481ced2b35c144afa74cbe14.svg";
export { ForwardRef as ReactComponent };